import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useTaskDrawer } from '../TaskDrawerContext';
import SubtaskItem from './SubtaskItem';

export default function TaskSubtasks() {
    const {
        subtasks,
        completedSubtasks,
        handleSubtaskDragEnd,
        handleToggleSubtask,
        handleDeleteSubtask,
        mode,
        pushTask,
        task,
        itemType,
    } = useTaskDrawer();

    const isMilestone = (task?.itemType === 'milestone') || (itemType === 'milestone');
    if (mode === 'create' && !isMilestone) return null;

    const completedCount = subtasks.filter((s) => s.status === 'Completed').length;

    return (
        <section data-tour="task-subtasks-section" className="space-y-3">
            <div className="flex justify-between items-center">
                <h3 className="font-headline font-bold text-on-surface text-sm flex items-center gap-1.5">
                    {isMilestone && <span className="text-amber-500 font-extrabold">◆</span>}
                    {isMilestone ? 'Tasks' : 'Subtasks'}{' '}
                    <span className="text-[#94a3b8] font-normal">
                        ({completedCount}/{subtasks.length})
                    </span>
                </h3>
                <button
                    onClick={() => pushTask('new', 'create', isMilestone ? 'New Task' : 'New Subtask', task._id)}
                    className="text-primary hover:text-[#006591] flex items-center gap-1 text-xs font-bold"
                >
                    <span className="material-symbols-outlined text-sm">add</span>
                    {isMilestone ? 'Add Task' : 'Create Subtask'}
                </button>
            </div>

            <DragDropContext onDragEnd={handleSubtaskDragEnd}>
                <Droppable droppableId="subtasks">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="space-y-1.5 max-h-[300px] overflow-y-auto pr-1"
                        >
                            {subtasks.map((sub, index) => (
                                <SubtaskItem
                                    key={sub._id}
                                    sub={sub}
                                    index={index}
                                    onToggle={handleToggleSubtask}
                                    onDelete={handleDeleteSubtask}
                                />
                            ))}
                            {provided.placeholder}
                            {subtasks.length === 0 && (
                                <div className="text-center py-6 border border-dashed border-[#e2e8f0] dark:border-[#303030] bg-white dark:bg-[#141414] rounded-xl">
                                    <span className="material-symbols-outlined text-2xl text-[#94a3b8] block mb-1">
                                        account_tree
                                    </span>
                                    <span className="text-xs text-[#94a3b8]">
                                        {isMilestone
                                            ? <>No tasks yet — click <strong>Add Task</strong> to add executable work under this milestone</>
                                            : <>No subtasks yet — click <strong>Create Subtask</strong> to break this task down</>
                                        }
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </section>
    );
}
